import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0687a26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-search-container" }
const _hoisted_2 = {
  key: 0,
  class: "line-group-container"
}
const _hoisted_3 = { class: "line-group-text" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "line-group-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-area" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], {
          class: "navigation-bar",
          title: $setup.getTitle,
          isUnderline: false
        }, {
          navTitleExtra: _withCtx(() => [
            ($setup.shouldShowLineTypes)
              ? (_openBlock(), _createBlock($setup["Tabs"], {
                  key: 0,
                  ref: "tabsComponent",
                  tabList: $setup.lineTypes,
                  currentTabIndex: $setup.currentSegmentIndex,
                  onOnChangeTab: $setup.onChangedSegmentIndex
                }, null, 8 /* PROPS */, ["tabList", "currentTabIndex"]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["title"]),
        _createVNode($setup["SearchInput"], {
          class: "search-input",
          name: "searchInput",
          fixed: true,
          onOnInput: $setup.onChangeSearchKeyword,
          onClearText: $setup.onChangeSearchKeyword,
          value: $setup.searchKeyword,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchKeyword) = $event)),
          valueModifiers: { trim: true }
        }, null, 8 /* PROPS */, ["value"]),
        ($setup.shouldShowDistricts)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["line-group-wrapper", {
            active: !$setup.currentDistricts.length,
          }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onClickDistrict('')))
              }, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(`전체(${$setup.getLinesCount("")})`), 1 /* TEXT */)
              ], 2 /* CLASS */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredDistricts, (district, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: idx,
                  class: _normalizeClass(["line-group-wrapper", {
            active: $setup.currentDistricts.includes(district),
          }]),
                  onClick: ($event: any) => ($setup.onClickDistrict(district))
                }, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(`${district}(${$setup.getLinesCount(district)})`), 1 /* TEXT */)
                ], 10 /* CLASS, PROPS */, _hoisted_4))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        _hoisted_6,
        _createElementVNode("div", {
          class: "search-result-container",
          onTouchstart: $setup.onTouchStart,
          onTouchend: $setup.onTouchEnd
        }, [
          ($setup.filteredLineInfos.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.filteredLineInfos, (lineInfo, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (lineInfo.turns[0].busStops.length)
                    ? (_openBlock(), _createBlock($setup["LineInfoRow"], {
                        key: 0,
                        lineInfo: lineInfo,
                        shouldHideFare: true,
                        onClick: ($event: any) => ($setup.goToLineInfoDetail(lineInfo))
                      }, null, 8 /* PROPS */, ["lineInfo", "onClick"]))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              }), 128 /* KEYED_FRAGMENT */))
            : (_openBlock(), _createBlock($setup["EmptyContent"], {
                key: 1,
                class: "empty-content",
                text: "일치하는 검색결과가 없습니다"
              }))
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}